<template>
  <div id="app">
    <RwvHeader />
    <router-view></router-view>
    <RwvFooter />
  </div>
</template>

<script>
import RwvHeader from "@/components/TheHeader";
import RwvFooter from "@/components/TheFooter";
import "@/assets/css/reset.css";
import "@/assets/css/style.css";
import "@/assets/css/pass.css";
// import '@/assets/css/slick-theme.css';
// import "@/assets/css/slick.css";
import "@/assets/css/reset.css";
import "@/assets/css/reset.css";
import Vue from "vue";
import VueCookies from "vue-cookies";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(VueCookies);

let version = 202512230913;
var versionCookies = Vue.$cookies.get("tenichi.source.version");
Vue.$cookies.set("tenichi.source.version", version);
if (version != versionCookies) {
  window.navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
  window.location.reload(true);
}

export default {
  name: "App",
  components: {
    RwvHeader,
    RwvFooter
  }
};
</script>

<style></style>
